import styled from "@emotion/styled"

const PostEventsEvents = styled.div`
  display: flex;
  overflow: auto;

  ${({ theme }) => theme.breakpoints.down("xl")} {
    gap: 16px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    gap: 100px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    gap: 150px;
  }
`

export default PostEventsEvents
